import {
	createSSRApp
} from 'vue'
import App from './App.vue'

import '@/styles/theme.css'
import '@/styles/global.css'

import MRow from '@/components/ui/Row.vue';
import MCol from '@/components/ui/Col.vue';
import MTabBar from '@/components/ui/Tabs.vue';
import MTag from '@/components/ui/Tag.vue';
import FeatureGrid from '@/components/ui/FeatureGrid.vue';
import MTextOverlay from '@/components/ui/TextOverlay.vue';
import MyLevel from '@/components/game/MyLevel.vue';
import MSwitch from '@/components/ui/Switch.vue';
import MButton from '@/components/ui/Button.vue';
import BaseModal from '@/components/dialog/BaseModal.vue';
import ConfirmDialog from '@/components/dialog/ConfirmDialog.vue';
import { api } from '@/api/index.js'

export function createApp() {
	const app = createSSRApp(App)
	app.component('MRow', MRow);
	app.component('MCol', MCol);
	app.component('MTag', MTag);
	app.component('MTabBar', MTabBar);
	app.component('MGrid', FeatureGrid);
	app.component('MTextOverlay', MTextOverlay)
	app.component('MyLevel', MyLevel)
	app.component('MSwitch', MSwitch)
	app.component('MBtn', MButton)
	app.component('BaseModal', BaseModal)
	app.component('ConfirmDialog', ConfirmDialog)
	app.config.globalProperties.$api = api
	return {
		app
	}
}